import React, {memo} from 'react';
import {format} from "date-fns";

import {Accordion} from "components/atoms";

const BazaarCurrentItemOrigin = ({details}) => {
    const releaseDate = details?.release_date ? format(new Date(details?.release_date),'MMMM do, yyyy').toUpperCase() : "-"
    const availableDate = details?.last_available ? format(new Date(details.last_available),'MMMM do, yyyy').toUpperCase() : "-"
    const initialPrice = details?.initial_price ? `$${details.initial_price} USD` : "-"
    const origin = details?.origin ?? "-"
    const retired = details?.retired ?? "-"

    return (
        <Accordion
            open={false}
            icon="origin"
            title="Origin"
        >
            <div className="origin-details-container">
                <InfoCard title="RELEASE DATE" value={releaseDate}/>
                <InfoCard title="LAST AVAILABLE" value={availableDate}/>
                <InfoCard title="INITIAL COST" value={initialPrice}/>
                <InfoCard title="ORIGIN" value={origin}/>
                <InfoCard title="RETIRED" value={retired}/>
            </div>
        </Accordion>
    )
}

export default memo(BazaarCurrentItemOrigin)

const InfoCard = ({title, value}) => (
    <div className="origin-details-container_info-card">
        <div className="origin-details-container_info-card_title">{title}:</div>
        <div className="origin-details-container_info-card_value">{value}</div>
    </div>
)